import { render, staticRenderFns } from "./problemReport.vue?vue&type=template&id=6bb10486&scoped=true"
import script from "./problemReport.vue?vue&type=script&lang=js"
export * from "./problemReport.vue?vue&type=script&lang=js"
import style0 from "./problemReport.vue?vue&type=style&index=0&id=6bb10486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb10486",
  null
  
)

export default component.exports